import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import OneFiveFlow from "@/components/Exercises/OneFive/OneFiveFlow";
import oneFiveAudio from "@/assets/audios/12345-Exercise.m4a";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/one-to-five/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [{ title: "5-4-3-2-1 Exercise - HAMD" }],
  }),
  beforeLoad: () => ({
    title: "oneFive.title",
    navbar: { showTitle: true },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };
  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="breathing.startExercise" />
        </Button>
      }
    >
      <p className="text-small">
        <FormattedMessage id="oneFive.intro" />
      </p>

      <MediaPlayer
        src={oneFiveAudio}
        segment={{ start: 0, end: 49 }}
        isPaused={isPausedAudio}
      />

      <OneFiveFlow isShow={showOverlay} onComplete={closeOverlay} onExit={closeOverlay} />
    </ExerciseLayout>
  );
}
